export default "__VITE_ASSET__f37e250d__"